import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 24.6c.433 0 .792-.142 1.075-.425.283-.283.425-.642.425-1.075v-7.35c0-.433-.142-.792-.425-1.075-.283-.283-.642-.425-1.075-.425-.433 0-.792.142-1.075.425-.283.283-.425.642-.425 1.075v7.35c0 .433.142.792.425 1.075.283.283.642.425 1.075.425Zm0 6.7c.467 0 .867-.167 1.2-.5.333-.333.5-.733.5-1.2 0-.467-.167-.867-.5-1.2a1.637 1.637 0 0 0-1.2-.5c-.467 0-.867.167-1.2.5-.333.333-.5.733-.5 1.2 0 .467.167.867.5 1.2.333.333.733.5 1.2.5Zm0 12.55c-.133 0-.258-.008-.375-.025a1.912 1.912 0 0 1-.325-.075c-4.467-1.333-8.133-4.075-11-8.225C9.433 31.375 8 26.817 8 21.85v-9.8c0-.633.183-1.208.55-1.725A3.166 3.166 0 0 1 9.95 9.2l13-4.85c.367-.133.717-.2 1.05-.2.333 0 .683.067 1.05.2l13 4.85a3.166 3.166 0 0 1 1.4 1.125c.367.517.55 1.092.55 1.725v9.8c0 4.967-1.433 9.525-4.3 13.675s-6.533 6.892-11 8.225l-.7.1Zm0-3c3.833-1.267 6.958-3.658 9.375-7.175S37 26.217 37 21.85v-9.8l-13-4.9-13 4.9v9.8c0 4.367 1.208 8.308 3.625 11.825 2.417 3.517 5.542 5.908 9.375 7.175Z",
  style: {"fill-rule":"nonzero"},
  transform: "translate(-5.018 -5.018) scale(1.20907)"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }